import Fetch, { resetFetched } from 'utils/fetch';
import extend from 'lodash/extend';
import clone from 'lodash/clone';

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. ACtion Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

const appState = {
    viewport: {
        width: 0,
        height: 0
    },
    fetching: {},
    fetched: {},
    fetchingErrors: [],
	fetchingServerError: [],
	fetchingAuthenticationError: []
};

/*******************************************************************************
 *  2. Action Types
 */

export const TYPEs = {
    DATA_FETCHING: 'dataFetching',
    DATA_FETCHED: 'dataFetched',
    DATA_RESET_FETCHED: 'resetFetched',
    DATA_FETCHING_ERROR: 'dataFetchingError',
	DATA_SERVER_ERROR: 'dataFetchingServerError',
	DATA_AUTHENTICATED_ERROR: 'dataFetchingAuthenticationError',
    APP_DATA: 'appData',
    FETCHED_APP_DATA: 'fetchedAppData',
    GET_VIEWPORT_SIZE: 'getViewportSize',
    SET_SPINNING: 'setSpinning'    
};

/*******************************************************************************
 *  3. Action Creators
 */

/*
 * sets viewport sizes to be accessed directly from the store.
 * gets updated on resize event
 */
export function getViewportSize() {
    return {
        type: TYPEs.GET_VIEWPORT_SIZE,
        width: window.innerWidth,
        height: window.innerHeight
    };
}

/*
 * clears the loadingError object when our ErrorModal is closed
*/
export function clearFetchingErrors() {
    return{
        type: TYPEs.CLEAR_FETCHING_ERRORS
    };
}

/*******************************************************************************
 *  4. Reducers
 */

export default ( state = appState, action ) => {

    /*
     * helper function that updates our fetching object
     */
    const fetching = ( bool ) => {
        return extend( {}, state.fetching, { [ action.fetching || action.fetched || action.fetchingError ]: bool } );
    };

    /*
     * helper function that updates our fetched object
     */
    const fetched = ( bool ) => {
        return extend( {}, state.fetched, { [ action.fetched ]: bool } );
    };

    switch( action.type ) {

        case TYPEs.GET_VIEWPORT_SIZE:
             return {
                ...state,
                viewport: {
                    width: action.width,
                    height: action.height
                }
             };

        case TYPEs.DATA_FETCHING:
            return{
                ...state,
                fetching: fetching( true )
            };

        case TYPEs.DATA_FETCHED:
            return{
                ...state,
                fetched: fetched( true ),
                fetching: fetching( false )
            };

        case TYPEs.DATA_RESET_FETCHED:
            return{
                ...state,
                fetched: fetched( false ),
                fetching: fetching( false )
            };
			
		case TYPEs.DATA_SERVER_ERROR:		    
			
            return{
                 ...state,
                fetchingServerError: {
                    ...state.fetchingServerError,
                    [ action.fetchingServerError ]: {
                        error: action.error,
                        message: action.error
                    }
                },
                fetched: fetched( true ),
                fetching: fetching( false )
            };
			
		case TYPEs.DATA_AUTHENTICATED_ERROR:
			if( action.error ) {
				alert(action.error);	
			}			
			window.location = '/wholesalechannelpartners/';
            return{
				...state,
                fetchingAuthenticationError: {
                    ...state.fetchingAuthenticationError,
                    [ action.fetchingAuthenticationError ]: {
                        error: action.error,
                        message: action.message
                    }
                },
                fetched: fetched( false ),
                fetching: fetching( false )
            };	

        case TYPEs.DATA_FETCHING_ERROR:
			window.location = '/wholesalechannelpartners/';
            return{
                ...state,
                fetchingErrors: {
                    ...state.fetchingErrors,
                    [ action.fetchingError ]: {
                        error: action.error,
                        message: action.message
                    }
                },
                fetched: fetched( false ),
                fetching: fetching( false )
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app-dux.js